<template>
  <div class="apply-list">
    <el-row style="margin-top: -35px; float: right; margin-right: 18px">
    </el-row>
    <el-row type="flex" :gutter="10" class="row">
      <!-- 操作部分 -->
      <el-col :span="9">
        <el-button
          @click="
            bulkImport = true;
            bulkImport1 = true;
            noData = true;
          "
          type="primary"
          size="small"
          plain
          >批量导入保单号</el-button
        >
        <el-button type="primary" plain size="small" @click="exportList(true)"
          >全部导出</el-button
        >
      </el-col>
      <!-- 查询部分 -->
      <el-col :span="7">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-select v-model="selectParam" placeholder="请选择" size="small">
              <el-option label="险种" value="insuranceType" />
              <el-option label="被保人姓名" value="recognizeeName" />
              <el-option label="被保人身份证号" value="recognizeeIdentity" />
              <el-option label="投保人" value="applicantName" />
            </el-select>
          </el-col>
          <el-col :span="12" v-if="selectParam === 'insuranceType'">
            <el-select
              v-model="queryParam.insuranceType"
              placeholder="请选择"
              size="small"
            >
              <el-option label="三者险" value="1" />
              <el-option label="车损险" value="2" />
              <el-option label="盗抢险" value="3" />
              <el-option label="人身意外险" value="4" />
              <el-option label="交强险" value="5" />
            </el-select>
          </el-col>
          <el-col :span="12" v-else>
            <el-input
              v-model="selectParamVal"
              size="small"
              placeholder="查询内容"
              clearable
            />
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5">
        <el-row>
          <el-date-picker
            v-model="paramDateArr"
            type="daterange"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width: auto"
          />
        </el-row>
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button size="small" @click="getSignLists">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-table
      class="data-list"
      :data="tableList"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      ref="dataList"
      v-loading="loading"
      @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
      key="typeOther"
    >
      <el-table-column type="selection" width="" />

      <el-table-column label="险种" width="300">
        <template slot-scope="scope">
          <div
            style="
              display: flex;
              color: #290202;
              font-weight: 800;
              font-size: 16px;
            "
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="insuranceTypeJudge(scope.row.insuranceType)"
              placement="bottom"
            >
              <p>
                {{ insuranceTypeJudge(scope.row.insuranceType) }}
                <span
                  style="font-size: 14px"
                  v-if="
                    scope.row.extendFieldsJson &&
                    scope.row.extendFieldsJson.vehicleBrand
                  "
                  >（{{ scope.row.extendFieldsJson.vehicleBrand }}）</span
                >
              </p>
            </el-tooltip>
          </div>
          <div v-if="scope.row.extendFieldsJson">
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                <p>车型：{{ scope.row.extendFieldsJson.motorcycleType }}</p>
                <p>车架号：{{ scope.row.extendFieldsJson.vin }}</p>
                <p>发动机号：{{ scope.row.extendFieldsJson.engineNumber }}</p>
              </div>
              <div>
                <p class="textEllipsis">
                  车型：{{ scope.row.extendFieldsJson.motorcycleType }}
                </p>
                <p class="textEllipsis">
                  车架号：{{ scope.row.extendFieldsJson.vin }}
                </p>
                <p class="textEllipsis">
                  发动机号：{{ scope.row.extendFieldsJson.engineNumber }}
                </p>
              </div>
            </el-tooltip>
          </div>
          <p class="textEllipsis">
            存证时间：{{ scope.row.preservationTime | formatDateHM }}
          </p>
          <p class="textEllipsis">
            开始时间：{{ scope.row.insuranceStartTime | formatDateTime }}
          </p>
          <p class="textEllipsis">
            结束时间：{{ scope.row.insuranceEndTime | formatDateTime }}
          </p>
          <p class="textEllipsis">
            保险年限：{{
              scope.row.insurancePeriod ? scope.row.insurancePeriod + "年" : ""
            }}
          </p>
          <p class="textEllipsis">
            保险金额：{{
              scope.row.extendFieldsJson
                ? scope.row.extendFieldsJson.insuredAmount
                : ""
            }}
          </p>
          <p class="textEllipsis">
            车牌号：{{
              scope.row.extendFieldsJson
                ? scope.row.extendFieldsJson.plateNumber
                : ""
            }}
          </p>
          <p class="textEllipsis">
            排量：{{
              scope.row.extendFieldsJson
                ? scope.row.extendFieldsJson.vehicleDisplacement
                : ""
            }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="被保人">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.recognizeeName"
            placement="bottom"
          >
            <p style="color: #000; font-size: 12px">
              {{ scope.row.recognizeeName }}
            </p>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.recognizeeIdentity"
            placement="bottom"
          >
            <p class="textEllipsis">
              身份证号：{{ scope.row.recognizeeIdentity }}
            </p>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="投保人">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">
              <p>{{ scope.row.applicantName }}</p>
              <p>
                证据类型：{{
                  applicantIdentityTypeJudge(scope.row.applicantIdentityType)
                }}
              </p>
              <p>证件号：{{ scope.row.applicantIdentity }}</p>
            </div>
            <div>
              <p class="textEllipsis" style="color: #000; opacity: initial">
                {{ scope.row.applicantName }}
              </p>
              <p class="textEllipsis">
                证据类型：{{
                  applicantIdentityTypeJudge(scope.row.applicantIdentityType)
                }}
              </p>
              <p class="textEllipsis">
                证件号：{{ scope.row.applicantIdentity }}
              </p>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="备案号/保单号">
        <template slot-scope="scope">
          <p
            class="color-success"
            style="
              font-size: 12px;
              color: rgba(41, 2, 2, 0.65);
              cursor: default;
              flex: 1;
              min-width: 150px;
              padding-top: 5px;
            "
          >
            &nbsp;&nbsp;备案号：{{ scope.row.preservationId }}
          </p>
          <p
            class="color-success"
            style="
              font-size: 12px;
              color: rgba(41, 2, 2, 0.65);
              cursor: default;
              flex: 1;
              min-width: 150px;
              padding-top: 5px;
            "
          >
            &nbsp;&nbsp;保单号：{{ scope.row.policyNumber }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
            v-if="scope.row.preservationId"
            @click="openCSDialog(scope.row)"
            class="com-normal-btn pointer"
            >证书</span
          >
          <p @click="showDialog(scope.row)" class="com-normal-btn pointer">
            录入保单号
          </p>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>
    <div class="bulkOperation" v-if="batchLength">
      <span style="margin-right: 20px"
        >已选 <span style="color: red">{{ batchLength }}</span
        >条数据</span
      >
      <el-button @click="downLoad" size="small">下载</el-button>
      <el-button size="small" @click="exportList(false)">导出</el-button>
    </div>

    <!--分页-->
    <el-row class="pageation row">
      <el-col :span="4">
        <div style="height: 20px"></div>
      </el-col>
      <el-col :span="20" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.itemPage"
          :pager-count="5"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParam.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="queryParam.total"
        />
        <el-go
          :page-size="queryParam.pageSize"
          :total="queryParam.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <!-- 手写loading -->
    <div
      v-show="batchLoading"
      style="
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1900;
      "
      v-loading="batchLoading"
      element-loading-text="合同发起中，请勿关闭当前页面"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    ></div>

    <!--    批量导入弹窗-->
    <el-dialog title="批量导入保单" :visible.sync="bulkImport" width="50%">
      <div v-if="bulkImport1 === true">
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding-bottom: 5px;
          "
        >
          <span style="padding-top: 5px"
            >可根据存证备案号上传多条存证数据对应的保单号，<a
              href="/template/保单号导入模板.xls"
              class="xiazai"
              >下载模板>></a
            ></span
          >

          <div style="display: flex">
            <el-upload
              :multiple="false"
              class="upload"
              action=""
              :auto-upload="false"
              :on-change="fileUploadSuccess"
              :show-file-list="false"
              accept=".xls,.xlsx"
            >
              <el-button size="small" type="primary">批量录入</el-button>
            </el-upload>
          </div>
        </div>

        <div
          v-if="noData"
          style="
            height: 350px;
            overflow: auto;
            margin: 10px 0;
            padding: 10px 0;
            text-align: center;
          "
        >
          <img
            src="../../static/images/web/nodata.png"
            style="width: 100%; height: max-content"
          />
          <p>暂无数据</p>
        </div>
        <!--        点击批量导入后展示的数据开始-->
        <div v-else-if="showData">
          <el-form
            :data="gridData"
            style="
              height: 300px;
              overflow: auto;
              border: 1px solid #e8e8e8;
              margin: 10px auto;
              padding: 10px 5px;
            "
          >
            <el-form-item
              v-for="(item, index) in gridData"
              :key="index"
              style="
                display: flex;
                justify-content: space-around;
                margin-bottom: 0px !important;
              "
            >
              <el-input
                size="small"
                placeholder="备案号"
                style="width: 100%; margin-right: 10px"
                v-model="item.preservationId"
                clearable
              ></el-input>
              <el-input
                size="small"
                placeholder="保单号"
                style="width: 100%; margin-right: 10px"
                v-model="item.policyNumber"
                clearable
              ></el-input>
              <el-date-picker
                v-model="item.insuranceStartTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="保单开始时间"
                size="small"
                style="width: 100%; margin-right: 10px"
              />
              <el-date-picker
                v-model="item.insuranceEndTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="保单结束时间"
                size="small"
                style="width: 100%; margin-right: 10px"
              />
              <!--              <el-input size="small" placeholder="结束时间(例如 2021-01-01)" style="width: 100%;margin-right: 10px"-->
              <!--                        v-model="item.insuranceEndTime" clearable></el-input>-->
              <el-button size="small" @click="deleteOne(index, gridData)">
                删除
              </el-button>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            class="dialog-footer"
            style="
              display: flex;
              justify-content: space-between;
              padding-bottom: 0px !important;
            "
          >
            <span style="line-height: 32px"
              >批量导入<span style="color: red">{{ gridData.length }}</span
              >条数据</span
            >
            <div>
              <el-button
                @click="
                  bulkImport = false;
                  gridData === '';
                "
                size="small"
                >取消
              </el-button>
              <el-button @click="AllSubmit()" size="small">全部提交</el-button>
            </div>
          </div>
        </div>
        <!--        点击批量导入后展示的数据结束-->
      </div>

      <div v-else-if="sureSubmit === true">
        <div style="height: 390px; overflow: auto">
          <div>
            <div class="signDialog-content">
              <div class="card">
                <div style="margin-bottom: 15px">
                  <img src="../../static/images/web/icon-yes.png" />
                  <span style="font-size: 14px; margin-left: 20px"
                    >已成功导入了{{ successCnt }}条数据对应的保单号</span
                  >
                </div>
                <div style="margin-bottom: 15px">
                  <img src="../../static/images/web/icon-no.png" />
                  <span style="font-size: 14px; margin-left: 20px"
                    >未查询到对应备案号的数据{{ failCnt }}条</span
                  >
                </div>
                <div>
                  <div v-for="(item, index) in failReasons" :key="index">
                    <p style="color: red; text-align: center">{{ item }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
          style="padding-bottom: 0px !important; text-align: right"
        >
          <div>
            <el-button @click="close()" size="small">关闭</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--    录入保单号弹窗-->
    <el-dialog title="录入保单号" :visible.sync="warrantyNumber" width="405px">
      <div class="dialog2">
        <p style="padding-left: 20px; margin-bottom: 10px">
          险种名称：{{ insuranceTypeJudge(insuranceType) }}
        </p>
        <p style="padding-left: 20px; margin-bottom: 10px">
          存证时间：{{ preservationTime | formatDateHM }}
        </p>
        <p style="padding-left: 20px; margin-bottom: 10px">
          备案号：{{ preservationId }}
        </p>
        <el-form :model="form">
          <el-form-item
            label="录入保单号:"
            :label-width="formLabelWidth"
            style="margin-left: 20px"
          >
            <el-input
              v-model="form.policyNumber"
              autocomplete="off"
              size="small"
              style="width: 214px"
              placeholder="请输入保单号"
              clearable
            ></el-input>
          </el-form-item>
          <!--         <el-form-item label="保单开始时间:" :label-width="formLabelWidth" style="margin-left: 50px" >-->
          <!--           <el-input v-model="form.insuranceStartTime" autocomplete="off" size="small" style="width: 70%;"-->
          <!--                     placeholder="YYYY-MM-dd"-->
          <!--                     clearable></el-input>-->
          <!--         </el-form-item>-->
          <!--         <el-form-item label="保单结束时间:" :label-width="formLabelWidth" style="margin-left: 50px" >-->
          <!--           <el-input v-model="form.insuranceEndTime" autocomplete="off" size="small" style="width: 70%;"-->
          <!--                     placeholder="YYYY-MM-dd"-->
          <!--                     clearable></el-input>-->
          <!--         </el-form-item>-->
          <el-form-item
            label="保单开始时间:"
            :label-width="formLabelWidth"
            style="margin-left: 20px"
          >
            <el-date-picker
              v-model="form.insuranceStartTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="保单开始时间"
              default-time="00:00:00"
              size="small"
              style="width: auto"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="保单结束时间:"
            :label-width="formLabelWidth"
            style="margin-left: 20px"
          >
            <el-date-picker
              v-model="form.insuranceEndTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="保单结束时间"
              default-time="23:59:59"
              size="small"
              style="width: auto"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="warrantyNumber = false">取消</el-button>
        <el-button size="small" style="width: 80px" @click="submitOne()"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <certiServiceDialog2
      v-if="cSDialogVisible"
      :dialogVisible="cSDialogVisible"
      listType="corpList"
      :param="{ preservationId }"
      @setCSDialogData="onSetCSDialogData"
    ></certiServiceDialog2>
  </div>
</template>

<script>
import {
  yaicExport,
  ApiMethods,
  postYaicList,
  parseExcel
} from "../../assets/js/http-serve/http-methods";
import CertiServiceDialog2 from "@/components/apply-list/certiServiceDialog2";
import ElGo from "../../components/go/Go";

export default {
  components: { CertiServiceDialog2, ElGo },
  data () {
    return {
      failReasons: [],
      failCnt: "",
      successCnt: "",
      preservationTime: "",
      insuranceType: "",
      preservationId: "",
      policyNumber: "",
      // 批量签loading
      batchLoading: false,
      tableList: null,
      // 请求参数
      queryParam: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        insuranceType: null, //险种(1:三者险 2:车损险 3:盗抢险)
        applicantName: null, //投保人姓名
        recognizeeName: null, //被保人姓名
        recognizeeIdentity: null //被保人证件号
      },

      selectedStatus: "",
      selectParamVal: "",
      paramDateArr: [],
      // 加载中显示
      loading: false,
      checkedList: [],
      batchLength: null,
      userId: "",
      //  修改后测试
      gridData: [],
      bulkImport: false,
      bulkImport1: true,
      form: {
        insuranceStartTime: "",
        insuranceEndTime: "",
        policyNumber: ""
      },
      formLabelWidth: "100px",
      formLabel: "left",
      targetId: "",
      sureSubmit: false,
      noData: true,
      showData: false,
      warrantyNumber: false,
      cSDialogVisible: false, //证书弹出框显示
      cSDialogData: {}, //证书弹出框数据
      selectParam: "insuranceType",
      batchApplyNos: "",
      selectedData: []
    };
  },
  created () {
    this.getSignLists();
  },
  computed: {
    statusEnum () {
      return [
        {
          label: "全部",
          value: "-1"
        },
        {
          label: "待审核",
          value: "-3"
        },
        {
          label: "待我签",
          value: "0"
        },
        {
          label: "待ta签",
          value: "1"
        },
        {
          label: "已完成",
          value: "2"
        },
        {
          label: "已拒签",
          value: "3"
        },
        {
          label: "已过期",
          value: "4"
        },
        {
          label: "已撤销",
          value: "5"
        }
      ];
    }
  },
  watch: {
    paramDateArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.queryParam.beginDate = val[0];
          this.queryParam.endDate = val[1];
        } else {
          this.queryParam.beginDate = this.queryParam.endDate = null;
        }
      },
      deep: true
    },

    selectParamVal (val) {
      this.queryParam[this.selectParam] =
        this.selectParam === "insuranceType"
          ? this.reverseInsuranceTypeJudge(val)
          : val;
    },
    selectParam: function (newVal, oldVal) {
      this.queryParam[oldVal] = null;
    }
  },
  methods: {
    //单个提交
    submitOne () {
      const param = {
        preservationId: this.preservationId,
        policyNumber: this.form.policyNumber,
        insuranceStartTime: this.form.insuranceStartTime,
        insuranceEndTime: this.form.insuranceEndTime
      };
      ApiMethods.UseEnterpriseController.postYaicInputNo(param)
        .then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          if (res.success) {
            this.policyNumber = this.form.policyNumber;
            this.$message({
              message: "保单号录入成功",
              type: "success"
            });
          }
          this.warrantyNumber = false;
          this.form.policyNumber = "";
          this.getSignLists();
        })
        .finally(() => (this.loading = false));
    },

    showDialog (row) {
      this.preservationId = row.preservationId;
      this.insuranceType = row.insuranceType;
      this.form.policyNumber = row.policyNumber;
      this.preservationTime = row.preservationTime;
      this.warrantyNumber = true;
      this.form.insuranceStartTime = row.insuranceStartTime;
      this.form.insuranceEndTime = row.insuranceEndTime;
    },

    fileUploadSuccess (file, fileList) {
      this.loading = true;
      let fd = new FormData();
      fd.append("excel", file.raw);
      parseExcel(fd).then(res => {
        this.loading = false;
        this.gridData = res.data;
        this.noData = false;
        this.showData = true;
      });
    },
    cellMouseEnter (row) {
      this.$set(row, "showTag", true);
    },
    cellMouseLeave (row) {
      row.showTag = false;
    },
    insuranceTypeJudge (type) {
      let insuranceType = "";
      if (+type === 1) {
        insuranceType = "三者险";
      } else if (+type === 2) {
        insuranceType = "车损险";
      } else if (+type === 3) {
        insuranceType = "盗抢险";
      } else if (+type === 4) {
        insuranceType = "人身意外险";
      } else if (+type === 5) {
        insuranceType = "交强险";
      }
      return insuranceType;
    },
    reverseInsuranceTypeJudge (type) {
      if (type === "三者险") {
        return 1;
      }
      if (type === "车损险") {
        return 2;
      }
      if (type === "盗抢险") {
        return 3;
      }
    },
    applicantIdentityTypeJudge (type) {
      let applicantIdentityType = "";
      if (+type === 1) {
        applicantIdentityType = "身份证";
      } else if (+type === 2) {
        applicantIdentityType = "护照";
      } else if (+type === 3) {
        applicantIdentityType = "台胞证";
      } else if (+type === 4) {
        applicantIdentityType = "港澳居民来往内地通行证";
      } else if (+type === 11) {
        applicantIdentityType = "营业执照";
      } else if (+type === 12) {
        applicantIdentityType = "统一社会信用代码";
      }
      return applicantIdentityType;
    },
    // 重置
    rest () {
      this.selectParam = "insuranceType";
      this.selectParamVal = "";
      this.paramDateArr = [];
      this.queryParam = {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        insuranceType: null, //险种(1:三者险 2:车损险 3:盗抢险)
        applicantName: null, //投保人姓名
        recognizeeName: null, //被保人姓名
        recognizeeIdentity: null //被保人证件号
      };
      this.getSignLists();
    },
    // 获取保险数据列表
    getSignLists () {
      let _this = this;
      this.loading = true;
      this.batchLength = null;
      this.$emit("batchLength", this.batchLength);

      postYaicList(this.queryParam)
        .then(data => {
          this.queryParam.itemPage = data.pageNum;
          this.queryParam.pageSize = data.pageSize;
          this.queryParam.total = data.total;

          if (data.success) {
            let temArray = data.data;
            _this.tableList = [];
            temArray.forEach((item, index) => {
              if (item.extendFields) {
                try {
                  item.extendFieldsJson = JSON.parse(item.extendFields);
                } catch (e) {
                  console.log(e);
                }
              }
              _this.tableList.push(item);
            });
          }
        })
        .catch(e => { })
        .finally(() => {
          this.loading = false;
        });
    },

    handleSizeChange (val) {
      this.queryParam.itemPage = 1;
      this.queryParam.pageSize = val;
      this.getSignLists();
    },
    handleCurrentChange (val) {
      this.queryParam.itemPage = val;
      this.getSignLists();
    },
    filterTag: function (row, column) {
      return row === column.status;
    },
    handleSelectionChange: function (val) {
      this.selectedData = val;
      this.batchLength = val.length;
      this.batchApplyNos = (val || []).map(i => i.id).join(",");
      let signNosArr = [];

      val.forEach(t => {
        signNosArr.push(t.signInfoNo);
      });
      this.signNos = signNosArr.join(",");
      this.$emit("batchLength", this.batchLength);
    },
    to: function (url, target) {
      window.open(url, target);
    },

    //证书
    openCSDialog (data) {
      this.cSDialogVisible = true;
      this.cSDialogData = data;
      this.preservationId = data.preservationId;
    },

    onSetCSDialogData (data) {
      this.cSDialogVisible = data.cSDialogVisible;
      this.cSDialogData = data.cSDialogData;
    },

    //下载
    downLoad () {
      this.loading = true;
      ApiMethods.UseEnterpriseController.yaicDownload({
        ids: this.batchApplyNos
      })
        .then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          this.downloadFile(res.data);
        })
        .finally(() => (this.loading = false));
    },
    async downloadFile (param) {
      param.fix = ".zip";
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },

    AllSubmit () {
      this.bulkImport1 = false;
      this.sureSubmit = true;
      ApiMethods.UseEnterpriseController.postYaicAll(this.gridData)
        .then(res => {
          if (res.success) {
            this.successCnt = res.data.successCnt;
            this.failCnt = res.data.failCnt;
            this.failReasons = res.data.failReasons;
          }
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
        })
        .finally(() => (this.loading = false));
    },
    close () {
      this.bulkImport = false;
      this.getSignLists();
    },
    allImport () {
      this.noData = false;
      this.showData = true;
    },
    //删除单条数据
    deleteOne (index, rows) {
      this.$confirm("此操作将删除该条数据, 是否继续?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        rows.splice(index, 1);
      });
    },

    //全部导出
    exportList (flag) {
      if (!this.paramDateArr || this.paramDateArr === "")
        return this.$message.error("请选择开始和结束时间");
      let param = JSON.parse(JSON.stringify(this.queryParam));
      if (!flag) {
        param.ids = this.batchApplyNos;
      }
      if (
        this.selectParam &&
        this.selectParamVal &&
        this.selectParamVal !== ""
      ) {
        param[this.selectParam] = this.reverseInsuranceTypeJudge(
          this.selectParamVal
        );
      }
      if (this.paramDateArr && this.paramDateArr !== "") {
        param.beginDate = this.paramDateArr[0];
        param.endDate = this.paramDateArr[1];
      }
      yaicExport(param).catch(err => {
        this.$message.error(err.description || "导出失败！");
      });
    }
  },
  name: "dataPreservation"
};
</script>

<style lang="less" scoped>
.v-modal {
  z-index: 99999;
}

.xiazai {
  font-weight: bold;
  color: #000;

  &:hover {
    cursor: pointer;
  }
}

.cancel {
  background-color: #ffffff !important;
  color: #000 !important;
  width: 80px;
  height: 32px;

  &:hover {
    background-color: #ec1c1c !important;
    color: #fff !important;
  }
}

.dialog2 /deep/ .el-form-item__content {
  margin-left: 0px !important;
}
.dialog2 /deep/ .el-form-item__label {
  text-align: left !important;
}
.dialog2 /deep/ .el-form-item {
  margin-bottom: 0px;
}
.no-data {
  padding: 0;
}

.card {
  padding-top: 50px;
}

.signDialog-content {
  padding-left: 25px;
  box-sizing: border-box;
  position: relative;

  .imgSignSus {
    width: 160px;
    height: 160px;
    position: absolute;
    top: 60px;
    left: 40px;
  }
}

.apply-list /deep/ .el-form-item__content {
  display: flex;
  align-items: center !important;
}

.hover-win {
  padding: 5px;

  .icontag:hover {
    background: whitesmoke;
  }
}

.nosign-url {
  font-size: 12px;
  color: #666666;
  margin-bottom: 20px;
}

.query-label {
  font-weight: 600;
  white-space: nowrap;
}

.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #290202;
  opacity: 0.65;
}

.edit {
  color: #290202;
  font-weight: bold;

  &:hover {
    color: #ec1c1c;
  }
}

.bulkOperation {
  width: 85%;
  height: 50px;
  background: #f9f9f9;
  position: absolute;
  top: 99px;
  left: 140px;
  display: flex;
  align-items: center;
  color: rgba(41, 2, 2, 0.45);
}

.apply-list {
  max-width: 1200px;
  margin: 0 auto;
}

.pageation {
  //margin-left: 80px;
  padding: 30px 10px 20px 10px;
  border-top: 0;
}

.dialog-footer {
  padding-bottom: 20px;

  .btn {
    width: 30%;
  }
}

nav.nav-bar {
  width: 100%;
  margin-top: 20px;
  border: 1px dashed #d7d7d7;
  overflow: hidden;

  li.nav-item {
    margin-right: 14px;
    padding: 10px 15px;
    color: #666;
    border: none;
    background: #fff;
    cursor: pointer;
  }

  .nav-item.active {
    color: #ec1c1c;
  }

  ul.nav {
    width: 100%;
  }
}

.color-success {
  cursor: pointer;
}

.custom-link {
  cursor: pointer;
  color: rgba(41, 2, 2, 1);
  font-weight: 800;
}

.custom-link:hover {
  color: #ec1c1c;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// pages/signInfo/dataPreservation.vue